import { render, staticRenderFns } from "./editAd.vue?vue&type=template&id=71b8f24e&scoped=true&"
import script from "./editAd.vue?vue&type=script&lang=js&"
export * from "./editAd.vue?vue&type=script&lang=js&"
import style0 from "./editAd.vue?vue&type=style&index=0&id=71b8f24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8f24e",
  null
  
)

component.options.__file = "editAd.vue"
export default component.exports